import React from 'react';
import { Progress, Container, Header } from 'semantic-ui-react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import { EPICS_PATH_CONTINUE } from 'volto-epics-addon/constants';
import { TASK_INTERMEDIATE_JOBS_VIEW } from 'volto-base-addon/constants';
import { useTaskPoll } from 'volto-epics-addon/helpers';
import { useUIDVariablesPoll } from '@package/helpers/useUIDVariablesPoll';
import UploadStepsContainer from './UploadStepsContainer';
import { useIntl, defineMessages } from 'react-intl';

const messages = defineMessages({
  applyingFaceBlur: {
    id: 'applyingFaceBlur',
    defaultMessage: 'Applying face blur…',
  },
  pleaseWaitProcessing: {
    id: 'pleaseWaitProcessing',
    defaultMessage: 'Please wait while your data is being processed…',
  },
  mustLoginFirst: {
    id: 'mustLoginFirst',
    defaultMessage: 'You must log in first.',
  },
});

const Page = () => {
  const history = useHistory();
  const intl = useIntl();
  const task = useTaskPoll(1000, TASK_INTERMEDIATE_JOBS_VIEW);
  const token = useSelector((state) => state.userSession.token);

  var mediaPageUid = '';
  var faceblurProgress = null;

  if (task) {
    mediaPageUid = task.variables.mediaPageUid;
  }

  const variables = useUIDVariablesPoll(
    1000,
    mediaPageUid,
    ['faceblurProgress'],
    mediaPageUid !== '',
  );

  var isAuthenticated = !!token;

  if (task?.completed === true) {
    history.push(EPICS_PATH_CONTINUE);
  }

  if (variables) {
    for (let key in variables) {
      if ('faceblurProgress' in variables[key]) {
        faceblurProgress = JSON.parse(variables[key].faceblurProgress);
        break;
      }
    }
  }

  return isAuthenticated ? (
    <Container className="waitforjobs-view-container">
      <UploadStepsContainer currentStep={3} totalSteps={4} />
      {faceblurProgress ? (
        <div style={{ marginTop: '3em' }}>
          <Header>{intl.formatMessage(messages.applyingFaceBlur)}</Header>
          <Progress percent={faceblurProgress.percentage} indicating progress />
        </div>
      ) : (
        <div style={{ marginTop: '3em' }}>
          <Header>{intl.formatMessage(messages.pleaseWaitProcessing)}</Header>
          <Progress percent={100} active />
        </div>
      )}
    </Container>
  ) : (
    <Container className="waitforjobs-view-container">
      <Header className="ui header">
        {' '}
        {intl.formatMessage(messages.mustLoginFirst)}{' '}
      </Header>
    </Container>
  );
};

export default Page;
